import { StringKey } from '../../../lang/index';
import { InvestmentType } from '../hooks/index';

export enum Column {
  AMOUNT_DUE = 'amount-due',
  DOCUMENTS = 'documents',
  EVENT = 'event',
  INVESTMENT_AMOUNT = 'investment-amount',
  INVESTMENT_DATE = 'investment-date',
  INVESTMENT_TYPE = 'investment-type',
  NO_OF_SHARES = 'no-of-shares',
  OWNERSHIP_PERCENTAGE = 'ownership-percentage',
  POST_MONEY_VALUATION = 'post-money-valuation',
  SHARE_CLASS = 'share-class',
  SHARE_PRICE = 'share-price',
}

export const investmentTypeTranslationKey: Record<InvestmentType, StringKey> = {
  [InvestmentType.FUNDRAISING_ROUND]: 'INVESTMENT',
  [InvestmentType.SAFE]: 'SAFE',
};

export const columnTranslationKey: Record<Column, StringKey> = {
  [Column.EVENT]: 'EVENT',
  [Column.INVESTMENT_DATE]: 'INVESTMENT_DATE',
  [Column.INVESTMENT_TYPE]: 'INVEST_TYPE',
  [Column.INVESTMENT_AMOUNT]: 'INVEST_AMOUNT',
  [Column.AMOUNT_DUE]: 'AMOUNT_DUE',
  [Column.SHARE_PRICE]: 'SHARE_PRICE',
  [Column.NO_OF_SHARES]: 'NO_OF_SHARES',
  [Column.OWNERSHIP_PERCENTAGE]: 'OWNERSHIP_PERCENT',
  [Column.SHARE_CLASS]: 'SHARE_CLASS',
  [Column.POST_MONEY_VALUATION]: 'POST_MONEY_VAL',
  [Column.DOCUMENTS]: 'DOCUMENTS',
};

export const columnOrderMap = Object.keys(columnTranslationKey);
